import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { Teacher } from '../interfaces/teacher';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {
  private db = firebase.firestore();
  constructor(private userService: UserService) {}

  /** Get the current logged-in teacher */
  async getTeacher(): Promise<Teacher | null> {
    const uid = this.userService.getUID();
    if (!uid) return null;

    const db = firebase.firestore();
    const docRef = db.collection('teacher').doc(uid);
    const docSnap = await docRef.get();

    if (!docSnap.exists) return null;

    return docSnap.data() as Teacher;
  }

  /** Get every teacher from the database */
  async getAllTeachers(): Promise<Teacher[] | null> {
    try {
      const snapshot = await firebase.firestore().collection('teacher').get();
      const teachers: Teacher[] = [];

      snapshot.docs.forEach(doc => {
        const data = { id: doc.id, ...(doc.data() as Teacher) };
        teachers.push(data);
      });

      return teachers;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  /** Get the correct teachers depending on the role */
  async getTeachersByRole(): Promise<Teacher[] | null> {
    try {
      const snapshot = await firebase.firestore().collection('teacher').get();
      const currentTeacher = await this.getTeacher();
      const currentRole = (currentTeacher?.role ? currentTeacher.role.toLowerCase() : '');
      const currentEmail = currentTeacher?.email;
      const currentSchool = currentTeacher?.school;

      const teachers: Teacher[] = [];

      snapshot.docs.forEach(doc => {
        const data = { id: doc.id, ...(doc.data() as Teacher) };
        if(currentRole === 'ghs teacher representative' || currentRole === 'teacher'){
          if(this.trimSchoolName(currentSchool?.toLowerCase()) === this.trimSchoolName(data.school.toLowerCase())){
            teachers.push(data);
          }
          else return;
        }else if(currentRole === 'admin'){
          teachers.push(data);
        }
      });
      return teachers;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  /** Trim school names in case there's 'school' trailing behind */
  private trimSchoolName(name: string | undefined | null): string {
    if (!name) return '';
    let trimmed = name.trim().toLowerCase();

    // Remove "school" (with or without spaces)
    trimmed = trimmed.replace(/\s*school\s*$/, '');
    return trimmed;
  }

  async getTeachersByExactRole(role: string): Promise<Teacher[]> {
    const snapshot = await firebase.firestore().collection('teacher').get();
    const teachers: Teacher[] = [];

    snapshot.docs.forEach(doc => {
      const data = { id: doc.id, ...(doc.data() as Teacher) };
      if (data.role === role) {
        teachers.push(data);
      }
    });

    return teachers;
  }

  async getTeacherByEmail(email: string): Promise<Teacher | null> {
    try {
      const snapshot = await this.db
        .collection('teacher')
        .where('email', '==', email)
        .limit(1)
        .get();

      if (snapshot.empty) {
        return null;
      }

      const teachers: Teacher[] = [];
      snapshot.docs.forEach(doc => {
        const data = { id: doc.id, ...(doc.data() as Teacher) };
        teachers.push(data);
      });

      // Return the first teacher
      return teachers[0] ?? null;
    } catch (err) {
      console.error('Error in getTeacherByEmail:', err);
      return null;
    }
  }
}
